// @ts-ignore
window.lcid = !window.lcid ? 'de-de' : window.lcid;
// @ts-ignore
window.locale = window.lcid.split('-').pop();

import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import locale_de from './lang/de';
import locale_en from './lang/en';
import locale_fr from './lang/fr';
import locale_es from './lang/es';
import locale_it from './lang/it';
import locale_pl from './lang/pl';
import locale_nl from './lang/nl';
import locale_cn from './lang/cn';
//import locale_ch from './lang/ch';
import locale_ru from './lang/ru';
import locale_cs from './lang/cs';
// @ts-ignore
import ServiceDownloads from "./components/ServiceDownloads";
// @ts-ignore
import ServiceVideos from "./components/ServiceVideos";
// @ts-ignore
import ServiceFaq from "./components/ServiceFaq";
// @ts-ignore
import SearchResult from "./components/SearchResult";
// @ts-ignore
import Vuebar from 'vuebar';
// @ts-ignore
//import VueYoutube from 'vue-youtube';
import VueScrollTo from 'vue-scrollto';
import {Route} from "vue-router/types/router";


// @ts-ignore
import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';


Vue.use(VueRouter);
Vue.use(Vuebar);
Vue.use(VueI18n);
Vue.use(vueFilterPrettyBytes);
Vue.use(VueScrollTo);
//Vue.use(VueYoutube);

Vue.config.productionTip = false;

// Ready translated locale messages
const messages = {
  de: locale_de,
  en: locale_en,
  fr: locale_fr,
  es: locale_es,
  it: locale_it,
  pl: locale_pl,
  nl: locale_nl,
  ch: locale_de,
  gb: locale_en,
  ru: locale_ru,
  cz: locale_cs,
  cn: locale_cn,
  in: locale_en,
};

// @ts-ignore


// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: window.locale, // set locale
  fallbackLocale: 'en',
  messages, // set locale messages
  dateTimeFormats: {
    'de': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'en': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'fr': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'es': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'it': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'ru': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'pl': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'ch': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'nl': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'cz': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'gb': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    },
    'in': {
      date: {
        year: 'numeric', month: 'short', day: 'numeric'
      }
    }
  }
});


const routes = [
  {
    name: 'downloads',
    path: '/downloads/:selection*',
    component: ServiceDownloads,
    props: function (route: Route) {
      if (!route.params.selection) {
        route.params.selection = "";
      }

      return {
        selection: Array.isArray(route.params.selection) ? route.params.selection : route.params.selection.split('/')
      };
    },
  },
  {
    name: 'search',
    path: '/search/:query*',
    component: SearchResult,
    props: function (route: Route) {
      if (!route.params.query) {
        route.params.query = "";
      }

      return {
        query: route.params.query
      };
    },
  },
  {name: 'videos', path: '/videos', component: ServiceVideos},
  {name: 'faq', path: '/faq', component: ServiceFaq}
];

const router = new VueRouter({
  routes: routes
});

router.beforeEach((to, from, next) => {

  if (!store.state.services)
    store.dispatch('getServices').then(() => {
      next()
    });
  else next();


});

Vue.filter('capitalize', function (num: any) {
  if (!num) return '';
  num = num.toString();
  return num.charAt(0).toUpperCase() + num.slice(1)
});

Vue.filter('category', function (category: any) {
  // @ts-ignore
  if (!category)
    return;

  // @ts-ignore
  if (!store)
    return;

  let title = [];

  let current = store.getters.findCategoryById(category);

  if (current) {
      title.push(current.title);
  }

  if (title.length)
    return title.pop();

  return "";

});
var pretty = Vue.filter('prettyBytes');

Vue.filter('prettyBytes', function (num: any, locale: any) {
  if (!locale) {
    // @ts-ignore

  }
  // @ts-ignore
  return pretty.apply(this, arguments);
});

Vue.filter('uppercase', function (num: any) {
  if (!num) return '';
  if (typeof num == 'string') {
    return num.toUpperCase();
  }
  return num;
});

new Vue({
  store,
  i18n,
  router,
  render: h => h(App),
  mounted() {
    this.$router.onReady(() => {
      const {query, category} = this.$route.query;

      store.commit('setSearchQuery', query);
      store.commit('selectSearchCategory', category);

      if (query) {
        store.dispatch('getResults');
      }
    });
  }
}).$mount('#service-portal');




